module.exports = __webpack_public_path__ + "static/img/brees-2002-top-image-thumb.9c22615.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-top-image-thumb.jpg
// module id = wwAC
// module chunks = 1